import request from "@/utils/request";
import { formateObjToParamStr, formateFenxiParamStr } from "@/utils";
// import { encryptByDES } from '@/utils/crypto'
import qs from "qs";
import axios from "axios";
const BASE_API = process.env.VUE_APP_BASE_API;
const REAL_BASE_API =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_REAL_BASE_API
    : process.env.VUE_APP_BASE_API;
const LOGIN_API = process.env.VUE_APP_LOGIN_API;
const FENXI_HOST = "https://fenxiplus.mktindex.com";
// update test env production cicd add rollback
export function getWordTs(param) {
  return request({
    url: `${BASE_API}/api/get_word_ts`,
    method: "get",
    params: param,
  });
}
export function getJdWordTs(param) {
  return request({
    url: `${BASE_API}/api/get_jd_ts`,
    method: "get",
    params: param,
  });
}
export function getDouyinWordTs(param) {
  return request({
    url: `${BASE_API}/api/get_dy_ts`,
    method: "get",
    params: param,
  });
}
export function getTbJdWordTs(param) {
  return request({
    url: `${BASE_API}/api/get_tbjd_ts`,
    method: "get",
    params: param,
  });
}
export function getVolumeTable(param) {
  return request({
    url: `${BASE_API}/api/ecommerce`,
    method: "post",
    data: param,
  });
}

export function setMarked(data) {
  return request({
    url: `${BASE_API}/api/marked`,
    method: "post",
    data,
  });
}
export function getMarked(param) {
  return request({
    url: `${BASE_API}/api/marked`,
    method: "get",
    params: param,
  });
}
export function getSearchMarked(param) {
  return request({
    url: `${BASE_API}/api/search_marked`,
    method: "post",
    data: param,
  });
}
export function getSearchData(param) {
  return request({
    url: `${BASE_API}/api/search`,
    method: "post",
    data: param,
  });
}
export function getDouyinSearchData(param) {
  return request({
    url: `${BASE_API}/api/douyin_search`,
    method: "post",
    data: param,
  });
}

//获取相关高频词组下载地址
export function getCloudDataUrl(param) {
  return `${REAL_BASE_API}/api/cloud?` + formateObjToParamStr(param);
}
//电商评论各方面声量下载地址
export function postVolumeDataUrl(param) {
  return `${BASE_API}/api/ecommerce?` + formateObjToParamStr(param);
}
//获取电商评论高频关键词下载地址
export function postECloudDataUrl(param) {
  return `${BASE_API}/api/ecloud?` + formateObjToParamStr(param);
}
//获取商品标题高频关键词下载地址
export function postTitleCloudDataUrl(param) {
  return `${BASE_API}/api/itemcloud?` + formateObjToParamStr(param);
}

//获取top类目下载地址
export function getCategoryDataUrl(param) {
  return `${REAL_BASE_API}/api/search?` + formateFenxiParamStr(param);
}
//获取top品牌下载地址
export function getBrandDataUrl(param) {
  return `${REAL_BASE_API}/api/search?` + formateFenxiParamStr(param);
}
//获取top商品下载地址
export function getCommodityDataUrl(param) {
  return `${REAL_BASE_API}/api/search?` + formateFenxiParamStr(param);
}
export function getCloudData(param) {
  return request({
    url: `${BASE_API}/api/cloud`,
    method: "get",
    params: param,
  });
}
// 商品标题词云图
export function getTitleCloudData(param) {
  return request({
    url: `${BASE_API}/api/itemcloud`,
    method: "post",
    data: param,
  });
}
export function getECloudData(data) {
  return request({
    url: `${BASE_API}/api/ecloud`,
    method: "post",
    data,
  });
}
export function getSocialData(param) {
  return request({
    url: `${BASE_API}/api/social`,
    method: "get",
    params: param,
  });
}
export function getPieChartData(param) {
  return request({
    url: `${BASE_API}/api/latest_social`,
    method: "get",
    params: param,
  });
}
export function getLineBarChartDataUrl(param) {
  return `${REAL_BASE_API}/api/search?` + formateObjToParamStr(param);
}
export function getPhone(param) {
  return request({
    url: `${BASE_API}/api/phone/setting`,
    method: "get",
    params: param,
  });
}
export function getMail(param) {
  return request({
    url: `${BASE_API}/api/get_mail_phone`,
    method: "get",
    params: param,
  });
}
export function setPhone(data) {
  return request({
    url: `${BASE_API}/api/phone/setting`,
    method: "PUT",
    data,
  });
}

export function addMail(data) {
  return request({
    url: `${BASE_API}/api/add_mail`,
    method: "POST",
    data,
  });
}
export function setPhoneNote(data) {
  return request({
    url: `${BASE_API}/api/phone/setting`,
    method: "POST",
    data,
  });
}
export function deletePhone(data) {
  return request({
    url: `${BASE_API}/api/phone/setting`,
    method: "DELETE",
    data,
  });
}
export function deleteMail(data) {
  return request({
    url: `${BASE_API}/api/del_mail`,
    method: "POST",
    data,
  });
}

export function getCatName(data) {
  return request({
    url: `${BASE_API}/api/get_catname`,
    method: "post",
    data,
  });
}

export function queryCatNum(data) {
  return request({
    url: `${BASE_API}/api/cat_num`,
    method: "post",
    data,
  });
}

export function getDwNotice(param) {
  return request({
    url: `${BASE_API}/api/dw_notice`,
    method: "get",
    params: param,
  });
}
export function clientError(data) {
  return request({
    url: `${BASE_API}/api/client_error`,
    method: "post",
    data,
  });
}
